<template>
    <b-btn v-if="isAvailable" @click="sendApprovalRequest" class="btn-card-action btn-card-action-danger my-1">Согласование</b-btn>
</template>

<script>
export default {
    name: 'cabinet-fl44-notice-card-request-approval-button',
    props: {
        purchase: {
            type: Object,
            required: true
        }
    },
    methods: {
        async sendApprovalRequest() {
            const confirmResult = await this.$bvModal.msgBoxConfirm(`Отправить извещение № ${this.purchase.purchase_info.reg_number} на согласование в ГРБС/МО?`, {
                title: 'Отправка извещения на согласование',
                okVariant: 'custom-green',
                okTitle: "Отправить на согласование",
                cancelTitle: 'Отмена',
                cancelVariant: 'custom-outline-secondary',
                noCloseOnBackdrop: true,
                noCloseOnEsc: true,
            });
            if (confirmResult) {
                await this.$api.personal.fl44.sendApprovalRequest(this.purchase);
                this.$emit('action');
            }
        }
    },
    computed: {
        isAvailable() {
            return this.purchase.actions.request_approval;
        }
    }
};
</script>
